module.exports = __webpack_public_path__ + "img/folder2.ce7672f9.svg";